import { render, staticRenderFns } from "./MultiAddCredit.vue?vue&type=template&id=565129f0&"
import script from "./MultiAddCredit.vue?vue&type=script&lang=js&"
export * from "./MultiAddCredit.vue?vue&type=script&lang=js&"
import style0 from "./MultiAddCredit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports